<template>
  <div
    v-loading="loding"
    class="wrap"
    v-if="appTheme.theme"
    :element-loading-text="language('register.loading')"
  >
    <div class="wrap_content">
      <div class="top_banner">
        <el-image
          style="width: 213px; height: 81px; margin-top: 20px"
          :src="logo2"
          fit="cover"
        ></el-image>
      </div>
      <div class="sys_title" :style="'color:' + appTheme.theme.themeColor">
        {{ language("register.title") }}
      </div>
      <div class="sys_subtitle" v-if="step != 3">
        <div class="sys_subtitle_2">
          <p v-html="languageTC('register.subTitle', appTheme.theme.title)"></p>
        </div>
      </div>
      <div class="login-form" v-if="step == 1">
        <el-card
          style="background: #f4eded; border-radius: 10px"
          shadow="never"
        >
          <div class="form_wrap">
            <el-tabs v-model="loginForm.type" stretch @tab-click="handleClick">
              <el-tab-pane
                :label="language('register.tabText')"
                name="phone"
              ></el-tab-pane>
              <el-tab-pane
                :label="language('register.tabText2')"
                name="email"
              ></el-tab-pane>
            </el-tabs>
            <el-form
              :model="loginForm"
              :rules="rules"
              status-icon
              ref="registerForm"
              class="form"
              size="small"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="loginForm.name"
                  :width="100"
                  :placeholder="
                    loginForm.type == 'phone'
                      ? language('register.placeholderLoginName')
                      : language('register.placeholderLoginName2')
                  "
                >
                  <el-select
                    v-model="area"
                    slot="prepend"
                    style="width: 100px"
                    v-if="loginForm.type == 'phone'"
                  >
                    <el-option label="+852" value="+852"></el-option>
                    <el-option label="+853" value="+853"></el-option>
                    <el-option label="+86" value="+86"></el-option>
                    <el-option label="+886" value="+886"></el-option>
                  </el-select>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="loginForm.password"
                  :width="100"
                  :placeholder="language('register.placeholderPassword')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password2">
                <el-input
                  type="password"
                  v-model="loginForm.password2"
                  :width="100"
                  :placeholder="language('register.placeholderPassword2')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  type="text"
                  v-model="loginForm.code"
                  :width="100"
                  :placeholder="language('register.placeholderCode')"
                >
                  <div slot="append">
                    <el-button
                      type="primary"
                      @click="getCode"
                      v-if="showGetCodebutton"
                      class="getCodeButton"
                      >{{ language("register.getCodeText") }}</el-button
                    >
                    <el-button
                      type="primary"
                      @click="getCode"
                      v-if="!showGetCodebutton"
                      >{{
                        languageTC("register.getCodeText2", timeText)
                      }}</el-button
                    >
                  </div>
                </el-input>
              </el-form-item>

              <el-form-item prop="captcha" :style="'margin-bottom:'+ (captchaWidth && showCaptcha?'18px':'0px')">
                <div class="captcha_wrap"  v-if="captchaWidth && showCaptcha"   >
                  <Captcha
                    buttonId="login_button"
                    @captchaVerifyCallback="captchaVerifyCallback"
                    :captchaWidth="captchaWidth"
                    :captchaHeight="32"
                  ></Captcha>
                </div>
              </el-form-item>

              <el-form-item prop="subPromoCode">
                <el-input
                  v-model="subPromoCode"
                  :width="100"
                  :placeholder="language('register.placeholdeSrubPromoCode')"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>

      <div class="rules_list_wrap" v-if="step == 1">
        <el-form
          :model="loginForm"
          :rules="rules"
          status-icon
          ref="registerForm2"
          size="small"
        >
          <el-form-item prop="checkedItem">
            <div class="rules_list">
              <el-checkbox v-model="checkedItem[0].checked"></el-checkbox>
              <template v-if="sdkInfo.bsKey && locale_lang == 'zh-HK'">
                <span class="user_check_item">
                  本人已閱讀及同意「SUPer Card」
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clauseTermsan)"
                    >會員條款、細則</span
                  >及
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clausePrivacyand)"
                    >私隱條款</span
                  >，並同意啟動「{{ appTheme.theme.title }}」服務接受其
                  <span
                    class="show_cursor"
                    @click="openTermsText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >條款細則</span
                  >及<span
                    class="show_cursor"
                    @click="openPrivacyText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >私隱條款</span
                  >。
                </span>
              </template>

              <template v-if="sdkInfo.bsKey && locale_lang == 'en'">
                <span class="user_check_item">
                  I have read and agreed to the
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clauseTermsan)"
                    >Terms & Conditions</span
                  >,
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clausePrivacyand)"
                    >Privacy Policy</span
                  >
                  of "SUPer Card." I also agree to activate the service of
                  {{ appTheme.theme.title }} and accept its
                  <span
                    class="show_cursor"
                    @click="openTermsText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >Terms & Conditions</span
                  >
                  and
                  <span
                    class="show_cursor"
                    @click="openPrivacyText(appTheme.theme)"
                    :style="'color:' + appTheme.theme.themeColor"
                    >Privacy Policy</span
                  >.
                </span>
              </template>

              <template v-if="sdkInfo.bsKey == '' && locale_lang == 'zh-HK'">
                <span class="user_check_item">
                  本人已閱讀及同意「SUPer Card」
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clauseTermsan)"
                    >會員條款、細則</span
                  >及
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clausePrivacyand)"
                    >私隱條款</span
                  >，並同意啟動「{{ appTheme.theme.title }}」服務。
                </span>
              </template>

              <template v-if="sdkInfo.bsKey == '' && locale_lang == 'en'">
                <span class="user_check_item">
                  I have read and agreed to the
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clauseTermsan)"
                    >Terms & Conditions</span
                  >,
                  <span
                    class="show_cursor"
                    :style="'color:' + appTheme.theme.themeColor"
                    @click="openW(clausePrivacyand)"
                    >Privacy Policy</span
                  >
                  of "SUPer Card." I also agree to activate the service of
                  {{ appTheme.theme.title }}
                </span>
              </template>
            </div>
            <div class="rules_list">
              <el-checkbox v-model="checkedItem[1].checked"></el-checkbox>
              <span class="user_check_item" v-if="sdkInfo.bsKey">{{
                languageTC("register.rules2", appTheme.theme.title)
              }}</span>
              <span class="user_check_item" v-if="sdkInfo.bsKey == ''">{{
                language("register.rules3")
              }}</span>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <!-- 服務列表 -->
      <div v-if="step == 2">
        <div class="serve_li_wrap_card_title">
          {{ language("openServiceLogin.tipsText2") }}
        </div>
        <el-card class="serve_li_wrap_card" shadow="never">
          <div class="serve_li_wrap">
            <div class="serve_li_title_back">
              <div class="serve_li_title">
                <div class="li_1"></div>
                <div class="li_2">{{ language("userInfo.serveStatus") }}</div>
                <div
                  class="li_3 11"
                  :style="'margin:' + (locale_lang == 'en' ? '0 20px' : '0px')"
                >
                  {{ language("userInfo.serveEmail") }}
                </div>
                <div class="li_4">{{ language("userInfo.serveRules4") }}</div>
              </div>
            </div>

            <div
              class="serve_li"
              v-for="(itmes, index) in listServe"
              :key="index"
            >
              <div class="li_1" @click="clickLogo(itmes)">
                <div>
                  <el-image
                    style="width: 50px; height: 50px"
                    :src="itmes.logo"
                    fit="cover"
                    class="merchant_list_img"
                  ></el-image>
                  <p class="serve_tips">
                    {{ itmes.name
                    }}<i
                      class="el-icon-warning name_tips"
                      :style="'color:' + appTheme.theme.themeColor"
                    ></i>
                  </p>
                </div>
              </div>
              <div class="li_2">
                <el-switch
                  v-model="itmes.selectedBiz"
                  :active-text="language('userInfo.open')"
                  :inactive-text="language('userInfo.close')"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeBusiness($event, itmes, index)"
                  :disabled="itmes.allowCancelBiz == 0 ? true : false"
                >
                </el-switch>
              </div>
              <div
                class="li_3"
                :style="'margin:' + (locale_lang == 'en' ? '0 20px' : '0px')"
              >
                <el-switch
                  v-if="itmes.selectedBiz"
                  v-model="itmes.selectedPush"
                  :active-text="language('userInfo.open')"
                  :inactive-text="language('userInfo.close')"
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="itmes.allowCancelPush == 0 ? true : false"
                >
                </el-switch>
              </div>
              <div class="li_4">
                <div>
                  <p>
                    <el-link :underline="false" @click="openTermsText(itmes)">{{
                      language("userInfo.serveRules4")
                    }}</el-link>
                  </p>
                  <p>
                    <el-link
                      :underline="false"
                      @click="openPrivacyText(itmes)"
                      >{{ language("userInfo.serveRules2") }}</el-link
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <!-- 服務列表 -->

      <div v-if="step == 3">
        <div class="wrap_reg_success">
          <div
            class="title_reg_success"
            :style="'border-bottom: 1px solid ' + appTheme.theme.themeColor"
          >
            {{ language("registerResult.tipsText1") }}
          </div>
          <div class="subtitle_reg_success">
            <!-- 恭喜，閣下已成功完成登記，我們將努力為閣下提供文化閱讀體驗。 -->
            {{ language("registerResult.tipsText2")
            }}{{ language("registerResult.tipsText3") }}
          </div>

          <template v-if="userOpneServeList.length > 0">
            <el-card
              class="serve_li_wrap_card serve_li_wrap_card2"
              shadow="never"
            >
              <div class="serve_li_wrap">
                <div class="serve_li_wrap_card2_title">
                  {{ language("registerResult.tipsText4") }}
                </div>
                <div
                  class="serve_li"
                  v-for="(itmes, index) in userOpneServeList"
                  :key="index"
                >
                  <div class="li_1" @click="clickLogo(itmes)">
                    <div>
                      <el-image
                        style="width: 50px; height: 50px"
                        :src="itmes.logo"
                        fit="cover"
                        class="merchant_list_img"
                      ></el-image>
                      <p class="serve_tips">
                        {{ itmes.name
                        }}<i
                          class="el-icon-warning name_tips"
                          :style="'color:' + appTheme.theme.themeColor"
                        ></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </template>

          <div class="main_button_reg_success">
            <!-- -->
            <el-button
              type="primary"
              plain
              style="width: 150px"
              @click="redirectURL"
            >
              {{ language("register.regSuccess") }}</el-button
            >
          </div>
        </div>
      </div>

      <div class="button_wrap">
        <div v-if="step == 1">
          <el-link type="primary" @click="goToLogin('login')">{{
            language("register.loginText")
          }}</el-link>
        </div>
        <div v-if="step == 2">
          <el-button @click="step = 1" type="primary" plain>{{
            language("register.lastStep")
          }}</el-button>
        </div>
        <el-button type="primary" @click="doRegister" v-if="step == 2">{{
          language("register.submit")
        }}</el-button>
        <el-button
          type="primary"
          style="width: 100px"
          @click="nextStep"
          v-if="step == 1"
          >{{ language("register.nextStep") }}</el-button
        >
      </div>

      <!-- <div class="merchant_wrap" v-if="appTheme.businesses&& appTheme.businesses.length>0">
        <div class="merchant_list">
          <span>{{ language("register.merchant") }}</span>
          <el-image
            v-for="(item, index) in appTheme.businesses"
            :key="index"
            style="width: 50px; height: 50px"
            :src="item.logo"
            fit="cover"
            class="merchant_list_img"
            @click="goTomerchant(item.logoJumpUrl)"
          ></el-image>
        </div>
      </div> -->

      <div class="extra_rules">
        <!-- <el-link :underline="false" class="extra_rules_list"
       :href="clauseMybookone"
          >有關「 一本」</el-link
        > -->
        <el-link
          :underline="false"
          class="extra_rules_list"
          :href="clauseSupercard"
          >{{ language("register.tipsText14") }}</el-link
        >
        <el-link
          :underline="false"
          class="extra_rules_list"
          :href="clauseTermsan"
          >{{ language("register.tipsText15") }}</el-link
        >
        <el-link
          :underline="false"
          class="extra_rules_list"
          :href="clausePrivacyand"
          >{{ language("register.tipsText16") }}</el-link
        >
      </div>
    </div>

    <el-dialog
      :title="language('register.tipsText17')"
      :visible.sync="showAPPExplain"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-html="appSummary" class="app_explain_button"></div>
    </el-dialog>
  </div>
</template>

<script>
const checkPhone = require("../rules/checkPhone.js").mixin;
const checkEmail = require("../rules/checkEmail.js").mixin;
const checkPassword = require("../rules/checkPassword.js").mixin;
import Captcha from "../components/Captcha.vue";
export default {
  mixins: [checkPhone, checkEmail, checkPassword],
  components: { Captcha },

  data() {
    return {
      clauseMybookone: process.env.VUE_APP_clauseMybookone,
      clauseSupercard: process.env.VUE_APP_clauseSupercard,
      clauseTermsan: process.env.VUE_APP_clauseTermsan,
      clausePrivacyand: process.env.VUE_APP_clausePrivacyand,
      loding: false,
      area: "+852",
      loginForm: {
        name: "",
        password: "",
        password2: "",
        code: "",
        type: "phone",
      },
      subPromoCode: "",
      rules: {
        name: [
          {
            required: true,
            message: this.language("register.rulesName"),
            trigger: "click",
          },
          { validator: this.checkLoginName, trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: this.language("register.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordOne, trigger: "blur" },
        ],
        password2: [
          {
            required: true,
            message: this.language("register.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordTwo, trigger: "blur" },
        ],
        code: [
          {
            required: true,
            message: this.language("register.rulesCode"),
            trigger: "click",
          },
        ],
        checkedItem: [
          //   {
          //     required: true,
          //     message: this.language("register.rulesCheckedItem"),
          //     trigger: "click",
          //   },
          { validator: this.checkCheckedItem, trigger: "blur" },
        ],
        captcha: [{ validator: this.checkCaptcha, trigger: "blur" }],
      },
      showGetCodebutton: true,
      timeText: 60,
      checkedItem: [
        {
          checked: true,
        },
        {
          checked: true,
        },
      ],
      step: 1, //臨時
      listServe: [],
      userOpneServeList: [],
      appSummary: "",
      showAPPExplain: false,
      logo: require("@/assets/logo.png"),
      logo2: require("@/assets/logo2.png"),
      user: {},

      verifyResult: {
        captchaResult: false,
        bizResult: "",
      },
      showCaptcha: false,
      captchaWidth: 358,
      timeR:null

    };
  },
  watch: {
    "loginForm.type": {
      handler(o, n) {
        if (o != n && o && n) {
          this.loginForm.name = "";
          this.loginForm.password = "";
          this.loginForm.code = "";
          this.loginForm.password2 = "";
          this.$refs["registerForm"].clearValidate();
        }
      },
      deep: true,
      immediate: true,
    },
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          this.getBusinessListInfo();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
    sdkInfo: function () {
      return this.$store.state.appData.sdkInfo;
    },
  },
  methods: {
    handleClick(o, n) {},
    checkLoginName(rule, value, callback) {
      let text = "";
      if (this.loginForm.type == "phone") {
        text = this.checkPhone(this.area, this.loginForm.name);
      } else {
        text = this.checkEmail(this.loginForm.name);
      }
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkPasswordOne(rule, value, callback) {
      let text = this.checkPassword(this.loginForm.password);
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkPasswordTwo(rule, value, callback) {
      let text = this.checkPasswordSame(
        this.loginForm.password,
        this.loginForm.password2
      );
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkCheckedItem(rule, value, callback) {
      if (this.checkedItem[0].checked) {
        callback();
      } else {
        callback(new Error(this.language("register.rulesCheckedItem")));
      }
    },
    checkCaptcha(rule, value, callback) {
      if (this.verifyResult.captchaResult == false && this.showCaptcha) {
        callback(new Error(this.language("login.captchaText")));
      } else {
        callback();
      }
    },
    nextStep() {
      this.$refs["registerForm"].validate((valid) => {
        if (valid) {
          this.$refs["registerForm2"].validate((valid) => {
            if (valid) {
              if (this.listServe.length > 0) {
                this.step = 2;
              } else {
                this.doRag();
              }
            } else {
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    doRegister() {
      let agreePushList = {};
      let openBisCodes = [];
      for (let index = 0; index < this.listServe.length; index++) {
        if (this.listServe[index].selectedBiz == 1) {
          openBisCodes.push(this.listServe[index].code);
          agreePushList[this.listServe[index].code] =
            this.listServe[index].selectedPush;
        }
      }
      this.doRag(agreePushList, openBisCodes);
    },
    doRag(agreePushList, openBisCodes) {
      this.loding = true;
      let nickName = "";
      if (this.loginForm.type == "phone") {
        nickName = this.loginForm.name.substring(
          this.loginForm.name.length - 4
        );
      } else {
        nickName = this.loginForm.name.split("@")[0];
      }
      let data = {
        type: this.loginForm.type,
        name: this.loginForm.name,
        password: this.loginForm.password,
        code: this.loginForm.code,
        isAgreePush: this.checkedItem[1].checked ? 1 : 0,
        nickName: nickName,
      };
      if (this.loginForm.type == "phone") {
        data.area = this.area;
      }
      if (agreePushList) {
        data.agreePushList = JSON.stringify(agreePushList);
      }
      if (openBisCodes) {
        data.openBisCodes = openBisCodes.join(",");
      }
      oauthSDK
        .register(data)
        .then((res) => {
          this.user = res.data;
          if (this.subPromoCode) {
            setTimeout(() => {
              //填優惠碼
              oauthSDK
                .saveSubPromoCode({ code: this.subPromoCode })
                .then((res) => {
                  this.loding = false;
                  this.$message.success(this.language("register.success"));
                  this.getUserOpneServeList();
                })
                .catch((err) => {
                  this.loding = false;
                  this.defalutToast(
                    this.language("register.success") + err.message
                  );
                  this.getUserOpneServeList();
                });
            }, 1000);
          } else {
            //沒填優惠碼
            this.loding = false;
            this.$message.success(this.language("register.success"));

            this.getUserOpneServeList();
          }
        })
        .catch((err) => {
          this.defalutToast(err.message);
          this.loding = false;
        });
    },
    getUserOpneServeList() {
      setTimeout(() => {
        oauthSDK
          .getServiceList()
          .then((res) => {
            this.step = 3;
            let userOpneServeList = [];
            for (let index = 0; index < res.length; index++) {
              if (res[index].status == 1) {
                userOpneServeList.push(res[index]);
              }
            }
            this.userOpneServeList = userOpneServeList;
          })
          .catch((err) => {
            console.log(err);
          });
      }, 1000);
    },
    getCode() {
      this.$refs.registerForm.validateField("name", (e) => {
        if (e == "") {
          this.$refs.registerForm.validateField("captcha", (e2) => {
            if (e2 == "") {
              let data = {};
              if (this.loginForm.type == "phone") {
                data = {
                  type: 0,
                  phone: this.loginForm.name,
                  area: this.area,
                };
              } else {
                data = {
                  type: 0,
                  email: this.loginForm.name,
                };
              }
              if (this.verifyResult.captchaResult == true && this.showCaptcha) {
                data.captcha = this.verifyResult.captcha;
              }
              oauthSDK
                .getRegisterCode(data)
                .then((res) => {
                  this.timeText = 60;
                  this.countTime();
                  this.showGetCodebutton = false;
                  // this.verifyResult = {
                  //   captchaResult: false,
                  //   bizResult: "",
                  // };
                })
                .catch((err) => {
                  // this.defalutToast(err.message);

                  if (err.code == 40003) {
                    this.showCaptcha = true;
                    this.verifyResult = {
                      captchaResult: false,
                      bizResult: "",
                    };
                  } else {
                    this.defalutToast(err.message);
                  }
                  this.loding = false;
                });
            }
          });
        }
      });
    },
    countTime() {
       window.clearInterval(this.timeR);
      this.timeR = setTimeout(() => {
        this.timeText = this.timeText - 1;
        if (this.timeText > 0) {
          this.countTime();
        } else if (this.timeText == 0) {
          this.showGetCodebutton = true;
          window.clearInterval(this.timeR);
        }
      }, 1000);
    },
    openTermsText(item) {
      window.open(item.termsUrl);
    },
    openPrivacyText(e) {
      window.open(e.privacyUrl);
    },
    clickLogo(e) {
      console.log(e);
      this.appSummary = e.introText;
      this.showAPPExplain = true;
    },
    goToLogin(url, query = {}) {
      this.goToPage({ url: url, query: query });
    },
    goTomerchant(url) {
      if (url) {
        window.open(url);
      }
    },
    openW(url) {
      window.open(url);
    },
    getBusinessListInfo() {
      oauthSDK
        .getRegisterBusinessList({})
        .then((res) => {
          this.listServe = res;
        })
        .catch((err) => {
          this.defalutToast(err.message);
        });
    },
    changeBusiness(event, e, index) {
      // console.log(this.listServe[index]);
      // if (this.listServe[index].selectedBiz == 0) {
      //   if (this.listServe[index].allowCancelPush == 1) {
      //     this.listServe[index].selectedPush = 0;
      //   }
      // }
    },
    redirectURL() {
      oauthSDK.redirectURL("redirect");
    },
    captchaVerifyCallback(e) {
      this.verifyResult = e;
      this.getCode();
    },
  },
  mounted() {},
  created() {},
};
</script>
<style>
.wrap .is-active {
  font-weight: bold;
}
</style>
<style lang="scss"  scoped>
.wrap {
  // height: 100vh;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrap_content {
  width: 668px;
  // border: 1px solid #bbbbbb;
  border-radius: 8px;
  padding: 26px 0 20px 0;
  background: #fff;
  // position: absolute;
  // top: 35%;
  // left: 50%;
  // margin-top: -200px;
  // margin-left: -324px;
}
.form_wrap {
  // width: 80%;
  margin: 0 auto;
}
.top_banner {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.sys_title {
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.sys_subtitle {
  // width: 400px;
  width: 394px;
  // text-align: center;
  font-size: 18px;
  margin: 12px auto 24px auto;
  display: flex;
  font-size: 14px;
  color: #101010;
  justify-content: space-around;
}
.sys_subtitle_2 {
  display: flex;
  align-items: center;
}
.login-form {
  margin: 0 auto;
  width: 400px;
}

.form {
  margin-top: 10px;
}
.user_check_item {
  margin-left: 10px;
  font-size: 12px;
  display: flex;
  span {
    display: inline-block;
  }
}
.show_cursor {
  text-decoration: underline;
  color: #2196f3;
  padding: 0 4px;
  cursor: pointer;
}
.rules_list_wrap {
  width: 448px;
  margin: 0 auto;
}
.rules_list {
  display: flex;
  align-items: baseline;
  // margin-bottom: 23px;
  margin-top: 14px;
  .user_check_item {
    display: block;
    line-height: 20px !important;
    color: #101010;
  }
}
.button_wrap {
  display: flex;
  justify-content: space-between;
  width: 450px;
  margin: 0 auto;
}
.merchant_wrap {
  padding: 20px 0 0 0;
  margin: 60px auto 0 auto;
  // width: 452px;
  width: 94%;
  display: flex;
  align-items: center;
  border-top: 1px solid #bcbcbc;
}
.merchant_list {
  // width: 452px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  span {
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    font-weight: 700;
    margin-right: 20px;
  }
  .merchant_list_img {
    margin-right: 25px;
    cursor: pointer;
    // border: 1px solid #c5c5c5c5;
  }
}
.extra_rules {
  display: flex;
  justify-content: end;
  // margin-top: 20px;
  margin-top: 50px;
  padding-right: 20px;
  box-sizing: border-box;
}
.extra_rules_list {
  margin-left: 20px;
}

//服務列表
.serve_li_wrap_card {
  background: #f4eded;
  border-radius: 10px;
  width: 90%;
  margin: 0 auto 20px auto;
}
.serve_li_wrap {
  // background: #fbfbfb;
  background: #fff;
  padding: 20px 0;
  .serve_li_title_back {
    width: 100%;
    background: #fff;
  }
  .serve_li_title {
    display: flex;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 10px;
    margin: 0 auto;
    width: 95%;
  }
  .serve_li {
    display: flex;
    padding: 10px 0;
    width: 95%;
    margin: 0 auto;
    border-bottom: 1px solid #bbbbbb;
    font-size: 14px;
  }
  .li_1 {
    width: 25%;
    display: flex;
    cursor: pointer;
    //   justify-content: center;
  }
  .li_2 {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;

    p {
      margin-bottom: 10px;
      text-align: center;
    }
  }
  .li_3 {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .li_4 {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      text-align: center;
    }
  }
  .serve_li_wrap .serve_li:last-child {
    border-bottom: none;
  }

  .merchant_list_img {
    // border: 1px solid #c5c5c5c5;
  }
}

.wrap_reg_success {
  width: 80%;
  margin: 20px auto 0 auto;
}
.title_reg_success {
  padding: 10px 0;
  // width: 100px;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}
.subtitle_reg_success {
  margin-top: 20px;
  width: 100%;
  color: rgba(16, 16, 16, 1);
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
  // line-height: 35px;
}

.main_button_reg_success {
  margin: 100px auto 0 auto;
  display: flex;
  justify-content: center;
  // @include mainRadiusButton(60%, 80px);
}

.name_tips {
  margin: 5px;
}
.app_explain_button {
  white-space: pre-wrap;
}
.serve_li_wrap_card_title {
  text-align: center;
  padding: 20px 0;
  font-weight: 700;
}
.serve_li_wrap_card2 {
  .li_1 {
    width: 100%;
    display: flex;
    justify-content: center;
    div {
      display: flex;
    }
    .serve_tips {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .name_tips {
        margin-bottom: 0px;
      }
    }
  }
  .serve_li {
    border: none;
  }
  .serve_li_wrap_card2_title {
    padding: 10px 0;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
  }
}
</style>